import { IObjectStringKeyMap } from '@shared/models';

export interface IDeploymentCheckGroup {
  groupID: string;
  questions?: string[];
}

export interface IDeploymentFrequency {
  count: number;
  days: string[];
  duration: number;
  reminder: boolean;
  startingTime: number;
  type: DeploymentFrequencyType;
  source?: string;
  templateIDs?: number[];
}

export enum DeploymentFrequencyType {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
  OnDemand = 'onDemand',
  Once = 'once',
  Custom = 'custom',
  FromProperty = 'fromProperty',
  External = 'external'
}

export interface IDeploymentTargets {
  targetType: string;
  assetTypes?: (string | number)[];
  assets?: (string | number)[];
  folders?: (string | number)[];
  locations?: (string | number)[];
  permissions?: (string | number)[];
  teams?: (string | number)[];
  users?: (string | number)[];
  zones?: (string | number)[];
}

export interface IDeployment {
  active: number;
  assignedTo: IObjectStringKeyMap<string[]>;
  checkID: string;
  created: number;
  creator: number;
  deploymentID: string;
  disabledAt: number;
  disabledBy: number;
  frequency: IDeploymentFrequency;
  checkGroups?: IDeploymentCheckGroup[];
  isLayerOf: string;
  lastUpdate: number;
  powerpoints: number;
  revision: number;
  showHistory: number;
  target: IDeploymentTargets;
  title: string;
}
